// src/redux/sagas/menuSaga.ts
import { call, put, takeEvery, select } from 'redux-saga/effects';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import {
  fetchMenuDataRequest,
  fetchMenuDataSuccess,
  fetchMenuDataFailure,
  setSelectedCategory,
  MenuItem,
} from '../slices/menuSlice';
import { fetchSiteContentSuccess } from '../slices/siteContentSlice';
import { updateWidgetsWithMenuData } from '../../utils/widgetDataUpdater';
import { RootState } from '../store';
import { shouldSkipApiCalls } from '../../utils/appConfig';
import staticMenuData from '../../data/menuData.json'
function* fetchMenuDataSaga(): any {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
      yield put(fetchMenuDataSuccess(staticMenuData))
    return;
  }

  try {
    // Get selected restaurant from Redux state
    const selectedRestaurant = yield select((state: RootState) => state.restaurant.selectedRestaurant);
    const restaurantId = selectedRestaurant?.restaurant_id;
    
    // Build URL with restaurant ID if available
    let url = `${ENDPOINTS.MENU_VIEW_API_PATH}?type=website`;
    if (restaurantId) {
      url += `&restaurantId=${restaurantId}`;
    }
    
    console.log('Fetching menu data with URL:', url);
    
    const response = yield call(request<MenuItem[]>, {
      method: 'GET',
      url,
    });
    yield put(fetchMenuDataSuccess(response.data));
    yield put(setSelectedCategory(null));
    
    // Update widgets with menu data AFTER menu data is successfully fetched
    const siteContent = yield select((state: RootState) => state.siteContent.data);
    
    if (siteContent) {
      // Update both widgets and homeWidgets if they exist
      const updatedSiteContent = { ...siteContent };
      
      if (siteContent.widgets) {
        const updatedWidgets = updateWidgetsWithMenuData(siteContent.widgets, response.data);
        updatedSiteContent.widgets = updatedWidgets;
      }
      
      if (siteContent.homeWidgets) {
        const updatedHomeWidgets = updateWidgetsWithMenuData(siteContent.homeWidgets, response.data);
        updatedSiteContent.homeWidgets = updatedHomeWidgets;
      }
         
      yield put(fetchSiteContentSuccess(updatedSiteContent as any));
    }
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to fetch menu data';
    yield put(fetchMenuDataFailure(errorMessage));
  }
}

export function* watchMenuSaga() {
  yield takeEvery(fetchMenuDataRequest.type, fetchMenuDataSaga);
}
